import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AudioRecorderService {
  private mediaRecorder: Record<string, MediaRecorder> = {};
  private chunks: Record<string, Blob[]> = {};

  async startRecording(qKey: string): Promise<void> {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    this.mediaRecorder[qKey] = new MediaRecorder(stream);
    this.chunks[qKey] = [];
    this.mediaRecorder[qKey].ondataavailable = (e) => {
      if (this.chunks[qKey] && e.data && e.data.size > 0) {
        this.chunks[qKey].push(e.data);
      }
    };
    this.mediaRecorder[qKey].start();
  }

  stopRecording(qKey: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      if (!this.mediaRecorder[qKey]) {
        reject(new Error(`No recording found for key: ${qKey}`));
        return;
      }

      // S'assurer que chunks existe
      if (!this.chunks[qKey]) {
        this.chunks[qKey] = [];
      }

      this.mediaRecorder[qKey].onstop = () => {
        const blob = new Blob(this.chunks[qKey] || [], { type: 'audio/webm' });
        // Nettoyer après l'arrêt
        delete this.mediaRecorder[qKey];
        delete this.chunks[qKey];
        resolve(blob);
      };

      // Gérer les erreurs potentielles
      this.mediaRecorder[qKey].onerror = (error) => {
        delete this.mediaRecorder[qKey];
        delete this.chunks[qKey];
        reject(error);
      };

      if (this.mediaRecorder[qKey].state === 'recording') {
        this.mediaRecorder[qKey].stop();
      } else {
        // Si l'enregistrement n'est pas en cours, nettoyer et rejeter
        delete this.mediaRecorder[qKey];
        delete this.chunks[qKey];
        reject(new Error(`Recording is not in recording state for key: ${qKey}`));
      }
    });
  }
}
